module.exports = __webpack_public_path__ + "static/forecast/weather/dayclear-d078f8c9f895d2ddb6d42aaa8ffed1ad.svg";